class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForm: `[action="${window.Shopify.routes.root}cart/add"]:not(.ctl-product-form [action="${window.Shopify.routes.root}cart/add"])`,
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      accordion: 'accordion', 
      product_description: '.product-description-container[read-more-qf]',
      quickview: '[open-quick-view]',
      quickviewModal: '.quick-view-container',
      quickviewClose: '.quick-view-container .close',
      fullBasket: '.additional-items-title',
    };

    this.init();
  }

  init() {
    window.log("Initializing global QF listeners");
    document.body.addEventListener('click', this.handleEvent.bind(this));
    document.body.addEventListener('submit', this.handleFormSubmit.bind(this));
    this.cartRelated();
    this.hideSpecialOfferModal();
    this.hideEmptyCardReview();
    this.hideEmptyPDPReview();
  }
  
  handleFormSubmit(e) {
    this.productForm(e);
  }
  
  handleEvent(e) {
    this.headerSearch(e);
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.productDescriptions(e);
    this.sideCartTabs(e);
    this.fullBasket(e);
    this.mobileMenu(e);
    this.openQuickView(e);
    this.closeQuickView(e);
    this.showSpecialOfferModal(e);
    this.hotspots(e);
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quantity }] });
      }
    }
  }

  productForm(e) {
    // PRODUCT FORM LISTENER
    // const productForms = document.querySelectorAll(this.selectors.productForms);
    const productForm = e.target.closest(this.selectors.productForm);
    if (productForm) {
      e.preventDefault();
      const quantity = productForm.querySelector("input.quantity-selector").value;
      const id = productForm.querySelector("#product-id").value;

      let properties = {};
      const propertyFields = productForm.querySelectorAll('.property');

      if (propertyFields) {
        propertyFields.forEach(field => {
          const key = field.getAttribute('name');
          const value = field.value;
          if (key && value) {
            properties[key] = value;
          }
        });
      }


      if (quantity && id) {
        window.cart.add({ items: [{ "id": id, "quantity": quantity, "properties": properties }] });
      }
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;
    
    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const variant_id = quantityElement.getAttribute("data-variant-id");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      let properties = {};
      const propertyFields = document.querySelectorAll(['line_item_property']);
      if (propertyFields) {
        propertyFields.forEach(field => {
          const key = field.getAttribute('data-key');
          const value = field.getAttribute('data-value');
          if (key && value) {
            properties[key] = value;
          }
        });
      }
      if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": 1, "properties": properties }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        const updated = current - 1;
        window.cart.change({ "id": variant_id, "quantity": updated });
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id);
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch(e) {
    const search = document.querySelector('.mega-menu .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .header-search-bar-wrapper .search-bar-qf input');
    const searchClose = document.querySelector('.mega-menu .header-search-bar-wrapper .search-close');
  
    if (search) {
      const target = e.target;

      if (target === searchTrigger || target.closest('[data-open-search]')) {
        if (!searchTrigger.classList.contains('active')) {
          searchTrigger.classList.add('active');
          search.classList.add('active');
          searchInput.focus();
        }
      } else if (target === searchInput) {
        // Do nothing if the search input is clicked
        return;
      } else if (searchInput.value.length == 0) {
        searchTrigger.classList.remove('active');
        search.classList.remove('active');
      } else if (target === searchClose || target.closest('.search-close')) {
        searchTrigger.classList.remove('active');
        search.classList.remove('active');
      }
  
      if (e.key === 'Escape') {
        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        }
      }
    }
  }

  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const predictiveSearch = document.querySelector('.predictive-search');
    const searchInput = document.querySelector('.mega-menu .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu [data-open-search]');

    if (menuTrigger && e.target.closest('#open-mobile-menu')) {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        predictiveSearch.classList.remove('active');
        searchInput.classList.remove('active');
        searchTrigger.classList.remove('active');
      } else {
        menu.classList.add('active');
        menuTrigger.classList.add('active');
        predictiveSearch.classList.remove('active');
        searchInput.classList.remove('active');
        searchTrigger.classList.remove('active');
      }
    }
  
    if (e.target === menu) {
      menu.classList.remove('active');
      menuTrigger.classList.remove('active');
      predictiveSearch.classList.remove('active');
      searchInput.classList.remove('active');
      searchTrigger.classList.remove('active');
    }
  }

  sideCartTabs(e) {
    if (e.target && e.target.closest) {
      const cartTab = e.target.closest('.cart-tab');
      
      if (cartTab && !cartTab.classList.contains('active')) {
        
        const cartTabs = document.querySelectorAll('.cart-tab');
  
        cartTabs.forEach(tab => {
          tab.classList.remove('active');
        });
  
        let tabSelected = cartTab;
        tabSelected.classList.add('active');
        let tabData = tabSelected.getAttribute('data-tab');
        let cartContents = document.querySelectorAll('.cart-content');
  
        cartContents.forEach(cartContent => {
          cartContent.style.display = 'none';
        });
  
        document.querySelector('.' + tabData).style.display = 'flex';
  
        if (tabData === 'saved-cart') {
          if (window.wishlist && window.wishlist.needsUpdate) {
            window.wishlist.initSideCartGrid();
            window.wishlist.needsUpdate = false;
          }
        }
      }
      const sideCartDrawer = document.querySelector('#cart-drawer-container');
      if (e.target == sideCartDrawer) {
          window.cart.closeSideCart();
      }
    }
  }

  /*
  accordions(e) {
    if (e.target.classList.contains(this.selectors.accordion) ) {
      e.preventDefault();
      
      const accordion = e.target;
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;
        
      if ( sibling_accordions ) {
        sibling_accordions.forEach((acc) => {
          if ( acc != accordion || accordion.classList.contains('active') ) {
            acc.nextElementSibling.style.maxHeight = null;
            acc.classList.remove("active");
            
          } else {
            accordion.classList.add("active");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
      
    }
  }
  */
  // accordions(e) {
  //   let target = e.target;

  //   if ( target.classList.contains('accordion-title') ) {
  //     //console.log('Accordion clicked', target );
  //     const selected_accordion = target.closest('.accordion-wrapper');
  //     const accordion_parent = target.closest('.accordion-category');
  //     if(selected_accordion.classList.contains('active')) {
  //       setTimeout(() => {
  //         selected_accordion.classList.remove('active');
  //       }, 100);
  //     } else if (accordion_parent) {
  //       //console.log('Accordion parent', accordion_parent);
  //       const sibling_accordions = accordion_parent.querySelectorAll('.accordion-wrapper');
  //       // Close sibling accordions 
  //       if (sibling_accordions) {
  //         sibling_accordions.forEach( accordion => {
  //             accordion.classList.remove('active');
  //         });
    
  //         setTimeout(() => {
  //           selected_accordion.classList.add('active');
  //         }, 100);
          
  //       }
  //     }
  //   }
  // }

  productDescriptions(e) {
      if ( e.target.classList.contains('read-more') ) {
        let el = e.target;

        if (el.classList.contains("active")) {
          el.classList.remove("active");
          el.innerHTML = "Read more";
        } else {
          el.classList.add("active");
          el.innerHTML = "Read less";
        }

      }
    
  }

  openQuickView(e) {
    // OPEN QUICK VIEW
    const quickView = e.target.closest(this.selectors.quickview);
    if (quickView) {
      e.preventDefault();
      let pageHasRecomendations = document.querySelector(".product-recommendations") || false;
      let timeout = pageHasRecomendations ? 2000 : 0;

      setTimeout(async () => {
          let quickViewModal = document.querySelector(this.selectors.quickviewModal);
      
          if (quickViewModal) {
            let quickViewModalInner = quickViewModal.querySelector(".inner");
      
            let sectionName = "gt-main-product";
      
            let handle = quickView.getAttribute("data-product-handle");
    
            if (handle) {
              try {
                const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let html = data[`${sectionName}`];
               
                  const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm);
                  console.log("🚀 ~ file: global_listeners.js:378 ~ GlobalListeners ~ setTimeout ~ scripts_to_run:", scripts_to_run)
                  const scripts = [];
                  
                  if (scripts_to_run != null) {
                    scripts_to_run.forEach(script => {
                      script = script.replace("</script>", "").replace("<script qv-run>", "");
                      script = script.replace('document.addEventListener("DOMContentLoaded", () => {', "");
  
                      let closingBraceLocation = script.lastIndexOf("});");
                      script = script.substring(0, closingBraceLocation);
                    
                      scripts.push(script);
                    });
                  }

                  if (quickViewModalInner && html) {
                    quickViewModalInner.innerHTML = html;

                    if (scripts.length > 0) {
                      scripts.forEach(script_to_eval => {
                        new Function(script_to_eval)();
                      });
                    }

                    window.restrictedShipping.checkProduct();


                    // init sliders
                    let gallery_thumbs_swiper = new window.swiper(".inner .thumb-swiper", {
                      navigation: {
                        nextEl: '.swiper-button-next.thumb',
                        prevEl: '.swiper-button-prev.thumb',
                      },
                      spaceBetween: 5,
                      slidesPerView: 3,
                      loop: false,
                      breakpoints: {
                          320: {
                            slidesPerView: 4,
                          },
                          576: {
                            slidesPerView: 5,
                          },
                          768: {
                            slidesPerView: 4,
                            spaceBetween: 15,
                          },
                      },
                      on: {
                        init: function () {
                              const adjust_slide_height = (slides) => {
                                slides.forEach(slide => {
                                  slide.style.height = slide.offsetWidth + 'px';
                                  console.log("adjust thumbs height")
                                })
                              };

                              let check_width = setInterval(() => {
                                const thumb_slider = document.querySelector('.inner .thumb-gallery .swiper-wrapper');
                                var thumb_swiper_slides = document.querySelectorAll('.inner .thumb-swiper .swiper-slide');
                          
                                if (thumb_slider && thumb_swiper_slides) {
                                  clearInterval(check_width);
                                  if (thumb_swiper_slides.length < 5) {
                                    thumb_slider.classList.add('center');
                                  }
                                  adjust_slide_height(thumb_swiper_slides);
                                }
                                    
                                document.querySelector('.gallery-container').style.opacity = 1;
                                    
                                window.addEventListener('resize', () => {
                                  if (thumb_swiper_slides) {
                                    adjust_slide_height(thumb_swiper_slides);
                                  }
                                });
                              }, 200);
                                
                                
                                  
                              }
                      },
                    });

                    let gallery_swiper = new window.swiper(".inner .main-swiper", {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {

                          const adjust_slide_height = (slides) => {
                            slides.forEach(slide => {
                              slide.style.height = slide.offsetWidth + 'px';
                            })
                          };

                          let check_width = setInterval(() => {
                            var main_swiper_slides = document.querySelectorAll('.inner .main-swiper-slide');
                    
                            if (main_swiper_slides) {
                              clearInterval(check_width);
                              adjust_slide_height(main_swiper_slides);
                            }
                              
                            document.querySelector('.gallery-container').style.opacity = 1;
                              
                            window.addEventListener('resize', () => {
                              if (main_swiper_slides) {
                                adjust_slide_height(main_swiper_slides);
                              }
                            });

                          }, 200);
                      },
                    },
                    });

                    // add listener for read more
                    let read_more = quickViewModalInner.querySelector(".product-description-container[read-more-qf]");

                    if (read_more) {
                      let read_more_control = read_more.querySelector(".read-more");
                      let excerpt = read_more.querySelector("span.excerpt");
                      let full = read_more.querySelector("span.full");

                      read_more_control.addEventListener("click", () => {
                        if (read_more.classList.contains("active")) {
                          read_more.classList.remove("active");
                          read_more_control.innerHTML = "Read more";
                        } else {
                          read_more.classList.add("active");
                          read_more_control.innerHTML = "Read less";
                        }
                      });
                    }

                    // Show quick view modal
                    quickViewModal.classList.add("active");
                  }
                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
        }
      }, timeout);
    }
  }

  closeQuickView(e) {
    // CLOSE QUICK VIEW
    const quickViewModal = document.querySelector(this.selectors.quickviewModal);
    const quickViewClose = e.target.closest(this.selectors.quickviewClose);
    let is_negative_space = false;
    if (e.target.classList.contains('quick-view-container')) {
      is_negative_space = true;
    }
    if (quickViewClose || is_negative_space) {
      if (quickViewModal) {
        quickViewModal.classList.remove("active");
      }
    }
  }

  fullBasket(e) {
    const fullBasket = e.target.closest(this.selectors.fullBasket);
    if (fullBasket) {
      e.preventDefault();
      const fullBasketContent = document.querySelector('.additional-items');
      if (fullBasketContent) {
        
        fullBasketContent.classList.add('active');
        fullBasket.classList.remove('active');
      }
    }
  }

  // Hotspots
  hotspots(e) {
    const target = e.target;
    const hotspots_section_or_snippet = target.closest('.hotspots-section') ? target.closest('.hotspots-section') : target.closest('.hotspots-snippet');

    // --=== Hepler Function ===--
    function clickHotspot( target_hotspot, all_hotspots ) {
      // Remove Active Classes
      all_hotspots.forEach( hotspot => { hotspot.classList.remove('active'); });
      
      target_hotspot.classList.add('active'); // Add Active Class
    }
    
    if ( hotspots_section_or_snippet ) {
      const hotspots = hotspots_section_or_snippet.querySelectorAll('.hotspot-wrapper');
      // console.log("🚀 Clicked Hotspot Section", target);
      
      // Hotspot Clicked
      if ( target.classList.contains('hotspot') && !target.classList.contains('active') ) {
          const hotspot_wrapper = target.closest('.hotspot-wrapper');
          const hotspot_index = hotspot_wrapper.getAttribute('data-hotspot-index');
          
          if ( hotspot_wrapper ) clickHotspot(hotspot_wrapper, hotspots);
          
          // Activate accordion if exists
          const hotspot_section = target.closest('.hotspots-section');
          if ( hotspot_section ) {
            const accordions = hotspot_section.querySelectorAll('.accordions .accordion-wrapper');
            if ( accordions ) {
              accordions.forEach( accordion => {
                const accordion_index = accordion.getAttribute('data-hotspot-index');
                if ( hotspot_index == accordion_index ) accordion.classList.add('active');
                else accordion.classList.remove('active');
              });
            }
          }
          
      } else if ( target.classList.contains("accordion-wrapper") ||  target.classList.contains("accordion-title") && !target.classList.contains('active') ) {
        const accordion = target.classList.contains('.accordion-wrapper') ? target : target.closest('.accordion-wrapper'); 
        const accordion_index = accordion.getAttribute('data-hotspot-index');
        const hotspot = hotspots_section_or_snippet.querySelector(`.hotspots-snippet .hotspot-wrapper[data-hotspot-index="${ accordion_index }"]`);
        
        // Activate hotspot when accordion is clicked
        if ( hotspot ) clickHotspot(hotspot, hotspots);
      }
    }
    
  }

  hideSpecialOfferModal() {
    // check for modal cookie
    const modal = document.querySelector('.gt-special-offer-banner');
    if (modal) {
      const checkCookie = (cookieName) => {
          var cookies = document.cookie.split(';');
          for (var i = 0; i < cookies.length; i++) {
              var cookie = cookies[i].trim();
              if (cookie.indexOf(cookieName + '=') === 0) {
                  return true; // Cookie found
              }
          }
          return false; // Cookie not found
      }

      // Check for a specific cookie
      var cookieName = 'gt-special-offer-modal';
      var hasCookie = checkCookie(cookieName);

      // Hide the element if the cookie is present
      if (hasCookie) {
          modal.classList.remove('active');
      }
    }
  }

  showSpecialOfferModal(e) {
    if (e.target.closest('[close-special-offer-modal]')) {
      const modal = document.querySelector('.gt-special-offer-banner');
      modal.classList.remove('active');
      // set cookie with 7 days expiry
      const setCookie = (cname, cvalue, exdays) => {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
      setCookie('gt-special-offer-modal', true, 7);
    }
  }

  hideEmptyPDPReview() {

    const targetNode = document.body; 
    const config = { childList: true, subtree: true }; 
  
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { 
              const cardReviewsAmount = node.querySelectorAll('.bv_numReviews_component_container .bv_numReviews_text');
              cardReviewsAmount.forEach(function(review) {
                if (review && review.textContent != '(0)') {
                  review.closest('.bv_main_container').classList.add('active');
                }
              });
            }
          });
        }
      }
    };
  
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  hideEmptyCardReview() {

    const targetNode = document.body; 
    const config = { childList: true, subtree: true };

    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { 
              const cardReviewsAmount = node.querySelectorAll('.bv_numReviews_component_container .bv_text');
              cardReviewsAmount.forEach(function(review) {
                if (review && review.textContent != '(0)') {
                  review.closest('.bv_main_container').classList.add('active');
                }
              });
            }
          });
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

  }
}

window.GlobalListeners = GlobalListeners;
